import React from 'react';
import Modal from '../Modal/Modal';
import './DeleteConfirmation.scss';
import { getUserDisplayName } from '../../../helpers/userDisplayName';

const DeleteConfirmation = ({ user, item_name, item_type = "user", onConfirm, onClose, isLoading = false }) => {
    const handleConfirm = () => {
        if (!isLoading) {
            onConfirm();
        }
    };

    // For backward compatibility with user deletion
    const displayName = user ? getUserDisplayName(user) : item_name;
    const title = user ? "Delete User Permanently" : `Delete ${item_type} Permanently`;

    return (
        <Modal onClose={onClose}>
            <div className="delete-confirmation">
                <h2>{title}</h2>
                <p>
                    Are you sure you want to <b>permanently delete</b> <b>{displayName}</b>?<br/>
                    <span style={{ color: '#c62828', fontWeight: 600 }}>This action is permanent and cannot be undone.</span>
                </p>
                <div className="modal-actions">
                    <button className="cancel-btn" onClick={onClose} disabled={isLoading}>
                        Cancel
                    </button>
                    <button className="confirm-btn" onClick={handleConfirm} disabled={isLoading}>
                        {isLoading ? 'Deleting...' : 'Delete Permanently'}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteConfirmation;
